module.exports = __webpack_public_path__ + "pdk2-5.jpg?b82076232399012a04dd5c48280a8e90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk2-5.jpg
// module id = 76
// module chunks = 0